import React, { useState } from "react";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import Img from "react-cool-img";

// components
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// Icons
import MenuIcon from "mdi-react/MenuIcon";

import Logo from "assets/logo/logo_nav_lightgray.svg";

const useStyles = makeStyles((theme) => ({
	tabBar: {
		position: "absolute",
		top: 0,
		background: "linear-gradient(rgba(0,0,0,0.8), rgba(255,255,255,0))",
		boxShadow: "none",
		zIndex: theme.zIndex.drawer + 1,
		height: 150,
		width: "100%",
	},
	grow: {
		flexGrow: 1,
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},
	tab: {
		color: "white",
		fontSize: 18,
		fontWeight: "bold",
		margin: 12,
	},

	title: {
		color: "white",
	},
	logoContainer: {
		cursor: "pointer",
	},
	logo: {
		marginRight: 12,
	},
	menuButton: {
		color: "white",
		"&:hover": {
			color: "#999999",
		},
	},
	link: {
		color: "#fff",
		opacity: 1,
		fontSize: "16px",
		"&:hover": {
			opacity: 0.6,
		},
	},
}));

const tabs = [
	{
		name: "產品",
		anchor: "prods",
		link: `${window.location.origin}/#prods`,
		target: false
	},
	{
		name: "操作說明",
		anchor: "howtouse",
		link: `${window.location.origin}/#howtouse`,
		target: false
	},
	{
		name: "創作者相框",
		anchor: "creators",
		link: `${window.location.origin}/#creators`,
		target: false
	},
	{
		name: "關於",
		anchor: "about",
		link: `${window.location.origin}/#about`,
		target: false
	},
	{
		name: "聯絡我們",
		anchor: "contact",
		link: `${window.location.origin}/#contact`,
		target: false
	},
	{
		name: "點位圖",
		anchor: "sitemap",
		link: `${window.location.origin}/#sitemap`,
		target: false
	},
	{
		name: "服務介紹",
		anchor: "contact",
		link: `https://medium.com/memopresso`,
		target: true
	},
];

function Header(props) {
	const classes = useStyles(props);
	const [anchor, setAnchor] = useState(false);

	function openLink(url, newTab) {
		newTab
		  ? window.open(url, "_blank", "noopener noreferrer")
		  : (window.location.href = url);
	}

	const menuList = () => (
		<div
			role="presentation"
			onClick={() => setAnchor(false)}
			onKeyDown={() => setAnchor(false)}
		>
			<List>
				{tabs.map(({ name, anchor,link,target }, index) => (
					<ListItem button key={`tab_${index}`}>
						<Button
							disableRipple
							disableFocusRipple
							disableElevation
							//href={`${window.location.origin}/#${anchor}`}
							onClick={ () => openLink(link , target)}
						>
							{name}
						</Button>
					</ListItem>
				))}
			</List>
		</div>
	);

	return (
		<>
			<AppBar position="fixed" className={classes.tabBar}>
				<Toolbar>
					<Img className={classes.logo} src={Logo} />
					<div className={classes.grow} />

					<Box
						className={classes.sectionDesktop}
						display={{ xs: "none", md: "block" }}
					>
						{_.map(tabs, ({ name, anchor,link,target }, index) => (
							<Button
								key={`tab_${index}`}
								className={classes.tab}
								//href={`${window.location.origin}#${anchor}`}
								onClick={ () => openLink(link , target)}
							>
								{name}
							</Button>
						))}
					</Box>

					<Box display={{ xs: "block", md: "none" }}>
						<IconButton
							className={classes.menuButton}
							aria-label="menu"
							onClick={() => setAnchor(true)}
						>
							<MenuIcon />
						</IconButton>
					</Box>
				</Toolbar>
			</AppBar>
			<SwipeableDrawer
				anchor="right"
				open={anchor}
				onClose={() => setAnchor(false)}
				onOpen={() => setAnchor(true)}
			>
				{menuList()}
			</SwipeableDrawer>
		</>
	);
}
export default Header;
